import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ArticleBody from "../../components/pages/blogs/singleBlog/ArticleBody";
import Comments from "../../components/pages/blogs/singleBlog/Comments";
import PageHeader from "../../components/pages/blogs/singleBlog/PageHeader";
import Shares from "../../components/pages/blogs/singleBlog/Shares";
import YouMayLike from "../../components/pages/blogs/singleBlog/YouMayLike";
import { blogs } from "../../constants/general/blogs";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { axios } from "../../lib/axios";

const SingleBlogPage = () => {
  const { blogName } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogName]);

  const [blogsData, setBlogsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchBlogData = () => {
    setIsLoading(true);
    axios
      .get(`/api/blogs/${blogName}`)
      .then((response) => {
        setBlogsData(response?.data?.data);
        console.log(blogsData?.image);

      })
      .catch((error) => {
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchBlogData();
  }, [blogName])

  return (
    <>

      <div>
        <PageHeader
          blogHeader={blogsData?.image}
          blog={blogsData}
        />
        <div>
          {!isLoading && (
            <>
              <ArticleBody blogContent={blogsData?.content} />
            </>
          )}
          <Shares blog={blogsData} />
          <Comments blog={blogsData} />
          <YouMayLike />
        </div>
      </div>
    </>
  );
};

export default SingleBlogPage;

// import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
// import ArticleBody from "../../components/pages/blogs/singleBlog/ArticleBody";
// import Comments from "../../components/pages/blogs/singleBlog/Comments";
// import PageHeader from "../../components/pages/blogs/singleBlog/PageHeader";
// import Shares from "../../components/pages/blogs/singleBlog/Shares";
// import YouMayLike from "../../components/pages/blogs/singleBlog/YouMayLike";
// import { blogs } from "../../constants/general/blogs";
// import { Helmet, HelmetProvider } from "react-helmet-async";

// const SingleBlogPage = () => {
//   const { blogName } = useParams();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [blogName]);

//   const filteredBlogs = blogs.filter((article) => article?.title === blogName);

//   const blogHeader = `/images/blog/blog${filteredBlogs[0]?.id}header.png`;

//   return (
//     <>
//       <HelmetProvider>
//         <Helmet>
//           <title>{filteredBlogs[0]?.title}</title>
//           <meta
//             name="description"
//             content={
//               filteredBlogs[0]?.id === 1
//                 ? "Discomfort is a common initial response to a new place or unfamiliar person"
//                 : filteredBlogs[0]?.id === 2
//                 ? "Traveling hazes non-existent boundaries between countries"
//                 : filteredBlogs[0]?.id === 3
//                 ? "For 21 days, Eduoard had no money for transportation"
//                 : "When you start traveling you should know your purpose of the journey."
//             }
//           />
//         </Helmet>
//         <div>
//           <PageHeader
//             blogHeader={blogHeader}
//             articleId={filteredBlogs[0]?.id}
//           />
//           <ArticleBody articleId={filteredBlogs[0]?.id} />
//           <Shares />
//           <Comments />
//           <YouMayLike />
//         </div>
//       </HelmetProvider>
//     </>
//   );
// };

// export default SingleBlogPage;